import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ProposalService } from 'src/app/_services/proposal.service';
import { APIErrorResponse } from 'src/app/_types/api-responses.types';
import { Lead } from 'src/app/_types/lead.types';
import { UpsertLeadRequest } from 'src/app/_types/proposals.type';

import { LeadFormComponent } from '../lead-form/lead-form.component';
import { SlideInModalComponent } from '../slide-in-modal/slide-in-modal.component';

@Component({
  selector: 'app-update-lead',
  templateUrl: './update-lead.component.html',
  styleUrls: ['./update-lead.component.css'],
  standalone: true,
  imports: [CommonModule, SlideInModalComponent, LeadFormComponent],
})
export class UpdateLeadComponent implements OnInit {
  @Input()
  leadId!: string;

  @Input()
  preload = true;

  private _lead!: Lead;

  @Input()
  set lead(value: Lead) {
    this._lead = value;
    if (value) {
      this.ngOnInit();
    }
  }

  get lead() {
    return this._lead;
  }

  memberId!: string;

  userId!: string;

  ready = false;

  isSubmitted = false;

  @ViewChild('leadForm') leadForm!: LeadFormComponent;

  constructor(
    private readonly proposalService: ProposalService,
    private readonly toastr: ToastrService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    if (!this.preload) return;
    this.fetchAndInit();
  }

  private fetchAndInit(): void {
    if (!this.lead)
      this.proposalService
        ._getPartnerLeadDetails({ leadId: this.leadId })
        .subscribe({
          next: (res) => {
            this._lead = res.data;
            this.initData();
          },
        });
    else {
      this.leadId = this.lead.leadId;
      this.initData();
    }
  }

  initData() {
    this.memberId = this.lead.familyMemberId!;
    this.userId = this.lead.userId!;
    if (this.leadForm) this.leadForm.resetForm();
    this.ready = true;
    this.cdr.detectChanges();
  }

  updateLead(obj: UpsertLeadRequest) {
    obj.metadata = { ...this.lead.metadata, ...obj.metadata };
    this.proposalService.patchLead(obj).subscribe({
      next: (res) => {
        this.toastr.success($localize`Lead modifié avec succès`);
        this.leadUpdated.emit();
        this.initData();
        this.closeModal();
        this.isSubmitted = false;
        this.cdr.detectChanges();
      },
      error: (err: HttpErrorResponse) => {
        const apiError = err?.error as APIErrorResponse;
        this.toastr.error(
          apiError?.error?.clientErrorMessageInFrench ??
            apiError?.error?.clientErrorMessage ??
            $localize`Une erreur est survenue. Veuillez réessayer`
        );
        this.isSubmitted = false;
      },
    });
  }

  @ViewChild('modal') modal!: SlideInModalComponent;

  @Output()
  leadUpdated = new EventEmitter();

  openModal() {
    if (!this.preload) {
      this.ready = false;
      this.modal.openModal();
      this.fetchAndInit();
      return;
    }
    this.modal.openModal();
  }

  closeModal() {
    this.modal.closeModal(false);
  }
}
